import { CheckCircleIcon, HourglassIcon, TriangleAlertIcon } from "lucide-react";

export const VendorsAssessmentStatusLabelMap = {
  // TPRA API Status Values (5 statuses) - aligned with Overview tab
  ["intake_form"]: {
    label: "Intake Form",
    borderColor: "#F59E0B",
    backgroundColor: "#FEF3C7",
    renderIcon: () => {
      return <TriangleAlertIcon size={13} />;
    },
  },
  ["due_diligence"]: {
    label: "Due Diligence",
    borderColor: "#3B82F6",
    backgroundColor: "#DBEAFE",
    renderIcon: () => {
      return <HourglassIcon size={13} />;
    },
  },
  ["review"]: {
    label: "In Review",
    borderColor: "#F59E0B",
    backgroundColor: "#FEF3C7",
    renderIcon: () => {
      return <TriangleAlertIcon size={13} />;
    },
  },
  ["reassessment"]: {
    label: "Reassessment",
    borderColor: "#3B82F6",
    backgroundColor: "#DBEAFE",
    renderIcon: () => {
      return <HourglassIcon size={13} />;
    },
  },
  ["complete"]: {
    label: "Reviewed",
    borderColor: "#10B981",
    backgroundColor: "#D1FAE5",
    renderIcon: () => {
      return <CheckCircleIcon size={13} />;
    },
  },
  // Legacy Vendors Module UI Status Values (3 statuses) - for backward compatibility
  ["pending_review"]: {
    label: "New Assessment",
    borderColor: "#006FEE",
    backgroundColor: "#006FEE1A",
    renderIcon: () => {
      return <HourglassIcon size={13} />;
    },
  },
  ["in_review"]: {
    label: "In Review",
    borderColor: "#F5A524",
    backgroundColor: "#F5A5241A",
    renderIcon: () => {
      return <TriangleAlertIcon size={13} />;
    },
  },
  ["reviewed"]: {
    label: "Reviewed",
    borderColor: "#1FCB6A",
    backgroundColor: "#1FCB6A1A",
    renderIcon: () => {
      return <CheckCircleIcon size={13} />;
    },
  },
} as const;
